import { module } from "angular";
import { KpiService } from "@gtmhub/kpis/services/kpiService";
import { KpiFormService } from "./services/kpi-form.service";

const mod = module("kpisCore", []);

mod.service("KpiFormService", KpiFormService);
mod.service("KpiService", KpiService);

export default mod.name;
